import { render, staticRenderFns } from "./InteractionType.vue?vue&type=template&id=3cc385f3&scoped=true"
import script from "./InteractionType.vue?vue&type=script&lang=js"
export * from "./InteractionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc385f3",
  null
  
)

export default component.exports